(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.factory('OnlineBookingLinkGeneratorService', ['$http', WebsiteServiceFn]);
    
    function WebsiteServiceFn($http) {

        var baseUrl = '/api/websites/';
        const colorUrl= '/api/administrations/colors';
        const labelUrl= '/api/agendalabels/';
        const userUrl= '/api/users/';

        var service = {
            getColors,
            getLabels,
            getGroupLabels,
            getBaseWeblink      
        };

        return service;

        function get(url) {
            return $http.get(url)
                        .then(function (response) {
                            return response.data;
                        });
        }

        function getColors() {
            return get(colorUrl);
        }
        function getLabels(agendaId) {
            return get(`${labelUrl}agenda/${agendaId}/false/true`);
        }

        function getLabelsByAgendaIds(agendaId) {
            return get(`${labelUrl}${ownerId}/agendas/${agendaId}`);
        }
        
        function getGroupLabels(groupId){
            return get(`${labelUrl}agendagroup/${groupId}/false`);
        }
        function getBaseWeblink(ownerId, agendaId, isGroupPractice = false, isRepresentative = false) {
            //representative appears to be currently unused
            if(isGroupPractice){
                return get(`${userUrl}${ownerId}/grouponlinebookinglink/agendas/${agendaId}`);
            }else{
                return get(`${userUrl}${ownerId}/singleonlinebookinglink/agendas/${agendaId}`);
            }
        }
        
    } 
})();